export function CreateGoogleMapsUrls(lat, long) {

    const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

    const streetviewMetadataUrl =
        "https://maps.googleapis.com/maps/api/streetview/metadata?size=640x480&location=" +
        lat +
        "," +
        long +
        "&fov=120&pitch=0&key=" +
        GOOGLE_MAPS_KEY;

    const streetviewUrl =
        "https://maps.googleapis.com/maps/api/streetview?size=640x480&location=" +
        lat +
        "," +
        long +
        "&fov=120&pitch=0&key=" +
        GOOGLE_MAPS_KEY;

    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap`
        + `?center=${lat},${long}`
        + `&zoom=16`
        + `&size=533x300`
        + `&markers=color:0x115451|size:mid|${lat},${long}`
        + `&key=${GOOGLE_MAPS_KEY}`;

    return {
        map: staticMapUrl,
        streetview: streetviewUrl,
    };
}
